module.exports = __webpack_public_path__ + "img/redanka.0d667bd9.png";